import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

class Edit extends React.PureComponent<any, any> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g>
                    <path d="M15.2,4.4c-0.2-0.2-0.4-0.2-0.6,0l-9.5,9.5c-0.2,0.2-0.2,0.4,0,0.6L9.6,19c0.2,0.2,0.4,0.2,0.6,0l9.5-9.5 c0.2-0.2,0.2-0.4,0-0.6L15.2,4.4z" />
                    <path d="M22.4,3.8l-2.2-2.2c-0.8-0.8-2.1-0.8-2.8,0l-1.1,1.1c-0.2,0.2-0.2,0.4,0,0.6l4.5,4.5c0.2,0.2,0.4,0.2,0.6,0l1.1-1.1 C23.2,5.8,23.2,4.5,22.4,3.8z" />
                    <path d="M4.2,15.6c-0.2-0.2-0.6-0.1-0.7,0.1L1,22.5c-0.1,0.3,0.2,0.6,0.5,0.5l6.7-2.5c0.3-0.1,0.4-0.5,0.1-0.7L4.2,15.6z" />
                </g>
            </SvgIcon>
        );
    }
}

export default Edit;
